import React, { useEffect, useState } from "react";

/* In-app replacements for window.confirm / window.prompt (both are silently blocked in installed PWAs).
   Usage: if (!(await confirmBox("Delete?"))) return;   const v = await promptBox("Amount?", "100"); if (v === null) return; */
let listener = null;
export const confirmBox = (message, opts = {}) => new Promise((resolve) => {
  if (!listener) { resolve(window.confirm(message)); return; }
  listener({ kind: "confirm", message, resolve, ...opts });
});
export const promptBox = (message, initial = "", opts = {}) => new Promise((resolve) => {
  if (!listener) { resolve(window.prompt(message, initial)); return; }
  listener({ kind: "prompt", message, initial: initial == null ? "" : String(initial), resolve, ...opts });
});

export const ConfirmHost = () => {
  const [req, setReq] = useState(null);
  const [val, setVal] = useState("");
  useEffect(() => { listener = (r) => { setVal(r.initial || ""); setReq(r); }; return () => { listener = null; }; }, []);
  if (!req) return null;
  const isPrompt = req.kind === "prompt";
  const done = (ok) => { req.resolve(isPrompt ? (ok ? val : null) : ok); setReq(null); };
  return (
    <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center bg-black/50 p-4" onClick={() => done(false)} data-testid="confirm-box">
      <div className="w-full max-w-sm rounded-3xl bg-white p-5 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="text-sm font-bold text-slate-900 whitespace-pre-line" data-testid="confirm-box-message">{req.message}</div>
        {isPrompt && <input autoFocus value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") done(true); }} className="mt-3 w-full rl-card px-3 py-2.5 text-sm font-mono outline-none" data-testid="confirm-box-input" />}
        <div className="flex gap-2 mt-4">
          <button onClick={() => done(false)} className="flex-1 rounded-2xl py-3 text-sm font-bold rl-card text-slate-700" data-testid="confirm-box-no">{req.noLabel || "Cancel"}</button>
          <button onClick={() => done(true)} className={`flex-1 rounded-2xl py-3 text-sm font-black text-white ${req.danger ? "bg-red-600" : "bg-slate-900"}`} data-testid="confirm-box-yes">{req.yesLabel || "OK"}</button>
        </div>
      </div>
    </div>
  );
};
